var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line;

var printPreservingEmptyLines = require('./print-preserving-empty-lines');

var inheritance = function inheritance(node, path, print) {
  if (node.baseContracts.length > 0) {
    return concat([' is', indent(concat([line, join(concat([',', line]), path.map(print, 'baseContracts'))]))]);
  }

  return '';
};

var body = function body(node, path, options, print) {
  if (node.subNodes.length > 0) {
    return concat([indent(line), indent(printPreservingEmptyLines(path, 'subNodes', options, print)), line]);
  }

  return '';
};

var ContractDefinition = {
  print: function print(_ref) {
    var node = _ref.node,
        options = _ref.options,
        path = _ref.path,
        _print = _ref.print;
    return concat([group(concat([node.kind, ' ', node.name, inheritance(node, path, _print), line, '{'])), body(node, path, options, _print), '}']);
  }
};
module.exports = ContractDefinition;